import React from 'react';

import PropTypes from 'prop-types';
import styles from './ImageWithCaption.module.scss';
import i18n from '../../i18n';
import classNames from 'classnames';

const ImageWithCaption = ({ image = {}, caption = '' }) => (
    <figure className={styles['ImageWithCaption']}>
        {console.log(image)}
        <picture className={styles['ImageWithCaption__ImageContainer']}>
            {image?.renditions?.smallWebp?.src && (
                <source
                    srcSet={image?.renditions?.smallWebp?.src}
                    media="(max-width: 639px)"
                    type="image/webp"
                />
            )}
            <source
                srcSet={image?.renditions?.small?.src}
                media="(max-width: 639px)"
            />
            {image?.renditions?.mediumWebp?.src && (
                <source
                    srcSet={image?.renditions?.mediumWebp?.src}
                    media="(min-width: 640px) and (max-width: 1200px)"
                    type="image/webp"
                />
            )}
            <source
                srcSet={image?.renditions?.medium?.src}
                media="(min-width: 640px) and (max-width: 1200px)"
            />
            <source
                srcSet={image?.renditions?.large?.src}
                media="(min-width: 1200px)"
            />
            <img
                className={styles['ImageWithCaption__Image']}
                sizes="343px"
                srcSet={`${image?.renditions?.medium?.src} 600w, ${image?.renditions?.large?.src} 1200w`}
                src={image?.renditions?.small?.src}
                alt={image?.alt}
                style={{
                    objectPosition: image?.focal?.x + ' ' + image?.focal?.y,
                }}
            />
        </picture>
        <figcaption className={styles['ImageWithCaption__Caption']}>
            {caption}
            {!!image?.credits && (
                <span
                    className={classNames(
                        styles['ImageWithCaption__Caption'],
                        styles['ImageWithCaption__Caption--Credits']
                    )}>
                    {i18n.t('generic.photo')} {image?.credits}
                </span>
            )}
        </figcaption>
    </figure>
);

ImageWithCaption.propTypes = {
    image: PropTypes.object,
    caption: PropTypes.string,
};

export default ImageWithCaption;
